import { Notificacion } from "@components/general/Alertas/Alertas";
import { invitarEstudiante } from "@helpers/httpRequests/httpRequestsForoEmpresarial/httpRequestsForoEmpresarial";
import { getUsuario } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const InvitarUsuarioExistente = ({ infoGrupo, setUsuarioAgregado, idGrupo }) => {

  const {t} = useTranslation();

  const [formValues, setFormValues] = useState({
    correo: "",
  });

  const handleOnChange = ({ currentTarget }) => {
    const { name, value } = currentTarget;

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleInvitacion = async (e) => {
    e.preventDefault();
    try {
      const enviarInvitacion = await invitarEstudiante({
        correo: formValues.correo,
        idGrupo,
      });

      setUsuarioAgregado(true);
      Notificacion("success", t('businessForum.coworkers.userAdded'));
    } catch (error) {
      console.log(error);
      Notificacion("error", t('businessForum.coworkers.userNotAdded'));
    }
  };

  return (
    <Container style={{ textAlign: "start" }}>
      <Row>
        <Col>
          <Form onSubmit={handleInvitacion}>
            <Form.Group>
              <Form.Label>{t('email')}:</Form.Label>
              <Form.Control
                className="mb-3"
                value={formValues.correo}
                name="correo"
                onChange={handleOnChange}
                type="email"
                placeholder={t("emailExample")}
              ></Form.Control>
              <small>
                {t('businessForum.coworkers.inviteCoworkerAdvice')}
              </small>
              
              <small>
                <ul className="mt-3">
                  <li>{t('businessForum.coworkers.coworkerInvitedInstructions')}</li>
                </ul>
              </small>
            </Form.Group>

            <Button type="submit" block>
              {t('businessForum.coworkers.addToGroup')}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default InvitarUsuarioExistente;
